<template>
  <div>
    <header-page :title="'Dashboard'" :hasBackLink="false"/>
   <!-- <div style="font-size: 20px">
      <router-link to="/ctrls">Controls</router-link>
    </div>
<br>
    <div style="font-size: 20px">
      <router-link to="/lbp-profile">LBP Profile</router-link>
    </div>-->
    
  </div>
</template>

<script>
import HeaderPage from '@/components/HeaderPage.vue'
export default {
  name: 'Dashboard',
  components: { HeaderPage },
}
</script>
